//储存 data数据
export function objData() {
    let data = {
        nRoomNumber: 1, //显示末端选项配置
        bShowFreshsText: true, //新风是否有文本
        bShowWaterText: true, //水系统是否有文本
        bShowText: true, //ailink是否显示输入文本
        bShowEnd: false, //显示末端选项
        bShowTips: false, //微信环境显示分享提示
        confit: {
            share_friend_title: "",
            share_friend_desc: "",
            share_img_url: "",
            share_link: "",
        }, //分享配置
        bShowNrom: false, //显示分享弹窗
        arrDeviceNav: [
            { titel: "区域" },
            { titel: "面积(㎡)" },
            { titel: "末端设备" },
            { titel: "制冷量" },
            { titel: "制热量" },
        ],
        nBright: 0,
        nPoints: 0,
        bShow: true, //淡入淡出动画
        secondIndex: 0, //二级导航分类
        nNavindex: 0, //导航索引
        arrNav: [
            {
                name: "配置选型",
                className: "confit_warp",
                atcName: "onconfit_warp",
            },
            {
                name: "设计方案",
                className: "reorpt_warp",
                atcName: "onreorpt_warp",
            },
            {
                name: "品牌优势",
                className: "case_warp",
                atcName: "oncase_warp",
            },
        ],
        arrErnav: [
            { title: "冷暖系统", open: true, openIndex: 0 },
            { title: "水系统", open: true, openIndex: 1 },
            { title: "新风系统", open: true, openIndex: 2 },
            { title: "集成产品", open: true, openIndex: 3 },
        ],
        arrClass: [
            { leftClass: "letfone" },
            { leftClass: "letftwo" },
            { leftClass: "letfthree" },
            { leftClass: "letffour" },
        ],
        arrVrList: [], //vr列表
        arrPos: [], //广告位列表
        reporInfo: {
            arrSub: [
                {
                    energy_percent: "",
                    arrCodsystem: [],
                    rooms: [{ product: [] }],
                },
            ],
            sub: [
                {
                    energy_percent: "",
                    energy_hot_area: "",
                    arrCodsystem: [],
                    rooms: [{ product: [] }],
                },
            ],
        }, //方案书详情
        arrSwiperImg: [
            {
                imgSrc: "https://pro-core.babycdn.com/2021/03aosmith/ant/diagram/0001.png",
                imgname: "",
            },
            {
                imgSrc: "https://pro-core.babycdn.com/2021/03aosmith/ant/diagram/0002.png",
                imgname: "",
            },
            {
                imgSrc: "https://pro-core.babycdn.com/2021/03aosmith/ant/diagram/0003.png",
                imgname: "",
            },
            {
                imgSrc: "https://pro-core.babycdn.com/2021/03aosmith/ant/diagram/0004.png",
                imgname: "",
            },
            {
                imgSrc: "https://pro-core.babycdn.com/2021/03aosmith/ant/diagram/0005.png",
                imgname: "",
            },
        ], //附件固定图片
        nRooms: 0, //楼层
        arrRanks: [], //根据城市推荐的案例
        bIpone: false, //判断是否为iponex
        bShowBtn: false,
        count: 0,
        bShowVideo: true, //是否到达位置播放视频
        bottomIndex: 0, //底部导航
        objOffer: {
            arrInfo: [],
        }, //报价
    }
    return data
}
//储存 需要加载的图片
export function arrImageUrl() {
    let data = [
        require("@/assets/images/antV2/scheme/bg.jpg"),
        require("@/assets/images/antV2/scheme/dian_icon.png"),
        require("@/assets/images/ant/progress_bg.png"),
        require("@/assets/images/ant/speed/speed-one.jpg"),
        require("@/assets/images/ant/speed/speed-two.jpg"),
        require("@/assets/images/ant/speed/speed-three.jpg"),
        require("@/assets/images/ant/speed/speed-four.jpg"),
        require("@/assets/images/ant/speed/new_six.jpg"),
        require("@/assets/images/ant/speed/new_seven.jpg"),
        require("@/assets/images/ant/speed/new_five.jpg"),
        require("@/assets/images/ant/speed/new_eight.jpg"),
        require("@/assets/images/ant/buying/buying_one.jpg"),
        require("@/assets/images/ant/buying/buying_two.jpg"),
        require("@/assets/images/ant/buying/buying_for.jpg"),
        require("@/assets/images/ant/buying/buying_five.jpg"),
        require("@/assets/images/ant/buying/buying_six.jpg"),
        require("@/assets/images/ant/sprite/buying_four.png"),
        require("@/assets/images/ant/sprite/buying_three.png"),
    ]
    return data
}